// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.input.search-group {
  width: 100%;
  padding: 8px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.modal-select-list {
  max-height: 70%;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 20px;
  background-color: rgb(240, 239, 239);
}

.select-item {
  /* padding: 10px;
  border-bottom: 1px solid #cbcbcb;
  cursor: pointer;
   */
  display: inline-block;
  background-color: #79b4f4;
  color: white;
  padding: 5px 10px;
  border-radius: 15px;
  margin-right: 10px;
  margin-bottom: 5px;
  max-width: 80%;
}

.select-item:hover {
  background-color: #236cbb;
}

.select-item:last-child {
  border-bottom: none;
}

.close-modal-button{
  width: 50%;
  background-color: rgb(245, 91, 91);
  height: 25px;
  border-style: none;
  border-radius: 7px;
  color: white;
  font-size: 20px;
}

.close-modal-button:hover{
  background-color: rgb(205, 49, 49);
}
`, "",{"version":3,"sources":["webpack://./src/components/excepciones-components/Maintenance/Maintenance-styles/modalSelector.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE;;;IAGE;EACF,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["\r\n.input.search-group {\r\n  width: 100%;\r\n  padding: 8px;\r\n  margin-bottom: 15px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n.modal-select-list {\r\n  max-height: 70%;\r\n  overflow-y: auto;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  padding: 20px;\r\n  background-color: rgb(240, 239, 239);\r\n}\r\n\r\n.select-item {\r\n  /* padding: 10px;\r\n  border-bottom: 1px solid #cbcbcb;\r\n  cursor: pointer;\r\n   */\r\n  display: inline-block;\r\n  background-color: #79b4f4;\r\n  color: white;\r\n  padding: 5px 10px;\r\n  border-radius: 15px;\r\n  margin-right: 10px;\r\n  margin-bottom: 5px;\r\n  max-width: 80%;\r\n}\r\n\r\n.select-item:hover {\r\n  background-color: #236cbb;\r\n}\r\n\r\n.select-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.close-modal-button{\r\n  width: 50%;\r\n  background-color: rgb(245, 91, 91);\r\n  height: 25px;\r\n  border-style: none;\r\n  border-radius: 7px;\r\n  color: white;\r\n  font-size: 20px;\r\n}\r\n\r\n.close-modal-button:hover{\r\n  background-color: rgb(205, 49, 49);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
